import { ValidationReturn } from '@/validators/countryInstanceValidators';
import { validateName } from '@/validators/name';

export function validateSurname(name: string, minLength = 2): ValidationReturn {
    return validateName(name, minLength);
}
